<template>
  <section class="hero__img" id="banner">
    <img :src="FixedHero" fetchpriority="high" :alt="altHero" />
  </section>
</template>

<script>
export default {
  data() {
    return {
      FixedHero: require("@/assets/hero_dois.jpg"),
      altHero:
        "Wagner Ramos - Front-end Developer"
    };
  }
};
</script>

<style>
.hero__img { background: #000;
  img {
    margin: 0 auto;
    display: block;
    height: auto;
    max-width: 100%;
    border: #000 1px solid;
  }
}
</style>
